import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createBrand',
    serviceName: 'admin',
    query: gql`
      mutation createBrand($title: String!, $code: String, $details: String, $is_active: Int, $producer_id: String) {
        createBrand(title: $title, code: $code, details: $details, is_active: $is_active, producer_id: $producer_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
